/** Agent configuration, OAuth URLs and tool audit bodies must not leave via telemetry. */
export function isPrivatePlatformRequest(url?: string): boolean {
  if (!url) return false;
  try { return /\/api\/v\d+\/(?:agent-platform|agent-knowledge-archives)(?:\/|$)/.test(new URL(url, 'https://local.invalid').pathname); }
  catch { return false; }
}
